import { useWorkflowStore } from "../stores/workflowStore.js";

let alwaysTimer = 0;
const ALWAYS_INTERVAL = 60;

export function tickWorkflow() {
  const workflow = useWorkflowStore();

  workflow.processSmeltingTick();
  workflow.processSmithingTick();

  alwaysTimer++;
  if (alwaysTimer >= ALWAYS_INTERVAL) {
    alwaysTimer = 0;
    workflow.runAlwaysWorkflows();
  }
}
